import ApiClient from './ApiClient';

class PersonalMessengerConnectionsAPI extends ApiClient {
  constructor() {
    super('personal_messenger_connections', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  status(id) {
    return axios.get(`${this.url}/${id}/status`);
  }

  connect(id, payload = {}) {
    return axios.post(`${this.url}/${id}/connect`, payload);
  }

  qr(id) {
    return axios.get(`${this.url}/${id}/qr`);
  }

  code(id, code) {
    return axios.post(`${this.url}/${id}/code`, { code });
  }

  password(id, password) {
    return axios.post(`${this.url}/${id}/password`, { password });
  }

  disconnect(id) {
    return axios.post(`${this.url}/${id}/disconnect`);
  }

  logout(id) {
    return axios.delete(`${this.url}/${id}/session`);
  }

  remove(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new PersonalMessengerConnectionsAPI();
